export const clientsWithManyTasks = [
  "nicoleelianeleroy@gmail.com",
  "vinciane.creutz@gmail.com",
];

export const clientsWithRecurrentTasks = [
  "nicoleelianeleroy@gmail.com",
  "vinciane.creutz@gmail.com",
];

export const inactiveClients = [
  "3mona3@gmail.com",
  "3d-2004@mail.ru",
  "3chouchou3@gmail.com",
  "3baram@gmail.com (future sp)",
  "2xtreme@live.be",
  "2emainmessages@gmail.com",
  "2cornuskousa@gmail.com",
];

export const serviceProvidersWithManyTasks = [
  "dhoste@belgacom.net",
  "primamusic2004@msn.com",
  "jeanclaude.falla@yahoo.fr",
];

export const validatedServiceProviders = [
  "britton.mark.w@gmail.com",
  "chakibbounaija@outlook.com",
  "cprost.com@gmail.com",
  "dahbigharbi@gmail.com",
  "fati.hbili@hotmail.com",
  "gerinjeanmichel@gmail.com",
  "hanoutsa@yahoo.fr",
  "i.taib@yahoo.be",
];

export const badServiceProviders = [
  "amraniim@gmail.com",
  "bodastevedoni@gmail.com",
  "jcbogaerts@hotmail.com",
];

export const serviceProvidersWithRecurrency = ["melinda.jehae@gmail.com"];

export const admins = ["s.scoumanne@gmail.com", "moderateur@listminut.com"];
